export const unpaidInvoice = {
    'no-unpaid': "aucune facture impayée",
}